export enum CookieType {
	ACCESS_TOKEN = "pos_dashboard_access_token",
	REFRESH_TOKEN = "pos_dashboard_refresh_token",
	CSRF_TOKEN = "pos_dashboard_csrf_token",
	LANG = "pos_dashboard_lang",
}
